import { Box } from '@chakra-ui/core'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { DEFAULT_CAMPAIGN_TYPE, DEFAULT_PARAMETER } from '../utils'

export const DefaultFormValues = () => {
  const { control } = useFormContext()
  return (
    <>
      <Controller
        name="products_cluster_data.parameter"
        control={control}
        defaultValue={DEFAULT_PARAMETER}
        as={<Box display="none" />}
      />
      <Controller
        name="campaign_type"
        control={control}
        defaultValue={DEFAULT_CAMPAIGN_TYPE}
        as={<Box display="none" />}
      />
    </>
  )
}
